import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=dd422380&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd422380')) {
      api.createRecord('dd422380', component.options)
    } else {
      api.reload('dd422380', component.options)
    }
    module.hot.accept("./agreement.vue?vue&type=template&id=dd422380&", function () {
      api.rerender('dd422380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/help/agreement.vue"
export default component.exports